// extracted by mini-css-extract-plugin
export var container = "ResumeSection-module--container--25Mx0";
export var title = "ResumeSection-module--title--2-CSh";
export var resume = "ResumeSection-module--resume--1V878";
export var resumeContainer = "ResumeSection-module--resumeContainer--1K4ym";